type Tab = { value: string; label: string };

/** 목록 상단 필터 탭(pill). */
export function FilterTabs({
  tabs,
  value,
  onChange,
}: {
  tabs: Tab[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-wrap gap-1">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          onClick={() => onChange(tab.value)}
          className="cursor-pointer rounded-[10px] px-3 py-1.5 text-sm font-medium transition-colors"
          style={
            value === tab.value
              ? { background: "var(--primary-soft)", color: "var(--primary)" }
              : { color: "var(--muted)" }
          }
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
